import { inject, Service } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WarningDialogComponent, WarningDialogData } from '../../components/warning-dialog/warning-dialog.component';
import { VariantId, variantIdToString } from '../../store/models/variant-id.model';
import { LogService } from './log.service';

export const COMMUNITY_FORUM_URL = 'https://community-forum.genoox.com/';

export type CommunityForumSource = 'HELP_MENU' | 'COMMUNITY_FEED';

@Service()
export class CommunityForumService {
  private dialog = inject(MatDialog);
  private logService = inject(LogService);

  openForumFlow(source: CommunityForumSource, variantId?: VariantId): void {
    this.logService
      .logBI({
        event_name: 'COMMUNITY_FORUM_BUTTON_CLICKED',
        analysis: variantId?.analysisId?.toString(),
        event_params: this.buildParams(source, variantId),
      })
      .subscribe();

    this.dialog.open(WarningDialogComponent, {
      width: '570px',
      backdropClass: 'popup-backdrop',
      panelClass: 'popup-panel',
      hasBackdrop: true,
      data: {
        title: 'Leaving Franklin',
        description: 'You are about to be redirected to an external application outside of the Franklin environment.',
        yesButtonLabel: 'Continue',
        cancelButtonLabel: 'Cancel',
        hideTopSection: true,
        yesButtonCallback: () => {
          this.logService
            .logBI({
              event_name: 'COMMUNITY_FORUM_NAVIGATION',
              analysis: variantId?.analysisId?.toString(),
              event_params: this.buildParams(source, variantId),
            })
            .subscribe();
          window.open(COMMUNITY_FORUM_URL, '_BLANK');
        },
      } as WarningDialogData,
    });
  }

  logForumButtonShown(variantId?: VariantId): void {
    this.logService
      .logBI({
        event_name: 'COMMUNITY_FORUM_BUTTON_SHOWN',
        analysis: variantId?.analysisId?.toString(),
        event_params: this.buildParams('COMMUNITY_FEED', variantId),
      })
      .subscribe();
  }

  private buildParams(source: CommunityForumSource, variantId?: VariantId): { key: string; value: string }[] {
    const params: { key: string; value: string }[] = [{ key: 'source', value: source }];
    if (variantId) {
      params.push({ key: 'variant', value: variantIdToString(variantId) });
    }
    return params;
  }
}
